import { ReactNode } from 'react';

export const TableCellCategory = ({
  text,
  subText,
}: {
  text: string | ReactNode;
  subText: string | ReactNode;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <p style={{ fontSize: 36, margin: 0 }}>{text}</p>
      <p
        style={{
          fontSize: 18,
          margin: 0,
          marginLeft: 8,
          fontWeight: 'bold',
          textAlign: 'left',
        }}
      >
        {subText}
      </p>
    </div>
  );
};
